import { Reveal } from "./Reveal";
import { Car, BatteryCharging, Wrench, RadioTower, Phone } from "lucide-react";
import { HERO_CLUSTER, PHONE_DISPLAY, PHONE_RAW } from "../../data/content";

const FEATURES = [
  { icon: Car, title: "Výroba autoklíčů", text: "Nové klíče a ovladače pro běžné značky vozidel podle typu a dostupnosti." },
  { icon: RadioTower, title: "Programování ovladačů", text: "Naprogramování a spárování dálkového ovládání s vaším vozem." },
  { icon: BatteryCharging, title: "Výměna baterií", text: "Rychlá výměna baterie v klíči i kontrola funkčnosti tlačítek." },
  { icon: Wrench, title: "Opravy a obaly", text: "Výměna prasklých obalů, oprava mikrospínačů a poškozených ovladačů." },
];

export const Autoklice = () => {
  return (
    <section
      id="autoklice"
      data-testid="autoklice-section"
      className="relative bg-brand-navy py-20 md:py-28 grain-overlay overflow-hidden"
    >
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(249,115,22,0.1),transparent_50%)]" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: image */}
          <Reveal>
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl shadow-black/50 ring-1 ring-white/10 aspect-[5/4]">
                <img
                  src={HERO_CLUSTER[0].url}
                  alt="Detail autoklíče a dálkového ovladače"
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </div>
              <span className="pointer-events-none absolute -top-3 -left-3 h-16 w-16 border-t-4 border-l-4 border-brand-orange rounded-tl-xl" />
              <span className="pointer-events-none absolute -bottom-3 -right-3 h-16 w-16 border-b-4 border-r-4 border-brand-orange rounded-br-xl" />
            </div>
          </Reveal>

          {/* Right: content */}
          <div>
            <Reveal>
              <p className="text-sm font-bold uppercase tracking-[0.2em] text-brand-orange mb-3">
                Specializace
              </p>
              <h2 className="font-heading font-black text-4xl sm:text-5xl text-white tracking-tight leading-none">
                Autoklíče a dálkové ovladače
              </h2>
              <p className="mt-5 text-base sm:text-lg text-slate-300 leading-relaxed">
                Vyrobíme nový autoklíč, naprogramujeme ovladač, vyměníme baterii
                nebo poškozený obal. Většinu situací vyřešíme přímo na provozovně
                v Ostravě.
              </p>
            </Reveal>

            <div className="mt-8 grid sm:grid-cols-2 gap-4">
              {FEATURES.map((f, i) => {
                const Icon = f.icon;
                return (
                  <Reveal key={f.title} delay={i * 0.06}>
                    <div className="flex gap-3.5 rounded-2xl bg-white/5 ring-1 ring-white/10 p-4 hover:bg-white/[0.08] transition-colors duration-300 h-full">
                      <span className="grid place-items-center h-11 w-11 shrink-0 rounded-xl bg-brand-orange/15 text-brand-orange">
                        <Icon className="h-5 w-5" strokeWidth={2.2} />
                      </span>
                      <div>
                        <h3 className="font-bold text-white text-[15px]">{f.title}</h3>
                        <p className="text-sm text-slate-400 mt-1 leading-snug">{f.text}</p>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>

            <Reveal delay={0.15}>
              <a
                href={PHONE_RAW}
                data-testid="autoklice-call-btn"
                className="mt-8 inline-flex items-center gap-2.5 rounded-full bg-brand-orange px-6 py-3.5 text-base font-bold text-white shadow-lg shadow-brand-orange/25 hover:bg-brand-orangeDark hover:-translate-y-0.5 transition-all duration-300"
              >
                <Phone className="h-5 w-5" strokeWidth={2.6} />
                Zavolat: {PHONE_DISPLAY}
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Autoklice;
